<template>
<div class="bto-sb-mybets-action">
  <div class="bto-sb-mybets-action-col">
      <span v-if="cashoutStep !== 1 && cashoutMsg" 
        class="bto-sb-mybets-cashout-text" 
        :class="{'bto-sb-mybets-cashout-text-wrong': cashoutStep !== 4}">
        {{t(cashoutMsg)}}
      </span>
      <inline-message-component
        v-else-if=" inlineMsg.betslipId === betDetails.betSlipGroupID && inlineMsg.text"
        :type="inlineMsg.type"
        :message="`${t(inlineMsg.text)}`"/>
      <inline-message-component class="bto-sb-mybets-cashout-message" 
        v-else-if="cashoutOnDemandMsg" 
        :type="cashoutOnDemandMsg.type" 
        :message="cashoutOnDemandMsg.text" />
      <span v-else></span>
  </div>
  <div class="bto-sb-mybets-action-col bto-sb-history">
    <cashout-on-demand v-if="showOnDemandCashout" 
      :betId="betDetails.betSlipGroupID" 
      :cashoutStep="cashoutOnDemandStep" 
      :cashoutAmount="cashoutOnDemandAmount"
      @changeStep="changeOnDemandStep" 
      @changeAmount="changeOnDemandAmount"
      @changeMsg="changeOnDemandMsg" />
    <template v-if="showCashout">
      <span v-if="cashoutCircularLoader" :class="{ 'bto-sb-mybets-cashout-load': cashoutCircularLoader === true }"></span>
      <button v-if="cashoutCircularLoader === false && (cashoutStep === 1 || cashoutStep === 2)" type="submit"
              @click="cancelCashout()" class="bto-sb-form-btn"> {{t('Mobile.cancelcashout')}}
      </button>
      <button v-if="cashoutCircularLoader === false && cashoutNewOffer === 0 && (cashoutStep === 3 || cashoutStep === 2)"
        class="bto-sb-form-btn bto-sb-form-btn-cashout-dw">
        {{t('M.CashoutSuspended')}}
      </button>
      <button v-else-if="cashoutCircularLoader === false && cashoutVal > 0" type="submit"
              class="bto-sb-form-btn bto-sb-form-btn-cashout-up" :disabled="isDisabled"
              @click="processCashout(cashoutVal)">
          <span :class="{ 'bto-app-icon bto-app-check': cashoutStep === 4}"></span>
          {{cashoutBtnName}} {{cashoutVal | formatAmountDisplay}}
      </button>
      <button v-if="cashoutCircularLoader === false && cashoutStep === 3" type="submit"
              class="bto-sb-form-btn bto-sb-form-btn-cashout-dw" @click="cancelCashout()">
          {{t('Mobile.newrejecttext')}}
      </button>
    </template>
    <button type="submit" class="bto-sb-form-btn" v-if="canPrintBetSlipFromHistory" @click="printTicket($event)">
      {{ t('Public.Print')}}
    </button>
    <rebet-button v-if="showRebet" :betDetails="betDetails" class="bto-sb-form-btn bto-sb-form-btn-green" />
    <paid-button
      class="bto-sb-form-btn"
      @printPaid="printTicket($event)"
      @changeStatusPaid="changeStatusPaid()"
      v-if="showPaidBtn"
      :agentEnv="true"
      :details-id="betDetails.betSlipGroupID"
      @showApiMsg="setInlineMsg" />
    <cancel-placed-betslip-button
      class="bto-sb-form-btn" 
      @printCancel="printCancelTicket($event)"
      v-if="showCancelPlacedBtn"
      :agentEnv="true"
      :details-id="betDetails.betSlipGroupID"
      @showApiMsg="setInlineMsg" />
  </div>
</div>
</template>
<script>
  import Base from './base';

  export default {
    name: 'MybetDetailsFooterWeb',
    extends: Base,
  };
</script>